// Components==============
import EvidenceCard from 'components/UI/EvidenceCard/EvidenceCard';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { GlobalEvidenceContext } from 'utilities/GlobalContext/GlobalEvidence';
import './BottomCards.module.scss';
// =========================

export default function BottomCards() {
  const translate = useTranslate();

  const evidence = useContext(GlobalEvidenceContext);

  const evidenceEntity = evidence?.[0];
  const evidenceEntity2 = evidence?.[1];

  return (
    <div styleName="column">
      <strong>{translate('general.terms.latest-uploaded-work')}</strong>

      {!!evidenceEntity && (
        <EvidenceCard evidence={evidenceEntity.evidence} height="initial" />
      )}
      {!!evidenceEntity2 && (
        <EvidenceCard evidence={evidenceEntity2.evidence} height="initial" />
      )}
    </div>
  );
}
